exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Banner_Banner__2LhXN{display:block;overflow:hidden;margin-bottom:30px}.Banner_Banner__2LhXN .Banner_BannerImg__DCuLs{width:100%}", ""]);

// exports
exports.locals = {
	"Banner": "Banner_Banner__2LhXN",
	"BannerImg": "Banner_BannerImg__DCuLs"
};